import { inlines } from './inlines';
export var heading = function heading(node) {
  var result = '';
  node.forEach(function (n) {
    result += inlines(n);
  });
  return "h".concat(node.attrs.level, ". ").concat(result);
};